import React, {Component} from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Button,
} from '@material-ui/core';
import query from 'query-string';

export default class TicketFail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: '',
    };
  }

  componentDidMount() {
    const error = query.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).error;
    this.setState({error: error});
  }

  render() {
    return (
      <div className="trainsaction-fail">
        <div className="header">Transaction Fail</div>
        <div className="trainsaction-fail-main">
          <Card>
            <CardHeader title="Transaction Error" />
            <CardContent>{this.state.error}</CardContent>
            <CardActions>
              <Button size="large">
                <a href="https://www.confirmtkt.com/rbooking-bus">CANCEL</a>
              </Button>
              <Button size="large">
                <a href="https://www.confirmtkt.com/rbooking-bus">RETRY</a>
              </Button>
            </CardActions>
          </Card>
        </div>
      </div>
    );
  }
}
